import { toast } from 'react-toastify';
import { Dialog, Transition } from '@headlessui/react';
import { IconQuestionMark } from '@tabler/icons-react';
import { Fragment, useState, useEffect } from 'react';
import { getAuthorizationHeader, http } from '../../config/http';

export default function ConfirmationRefundPenjualan({
  loadingRf,
  detailBarangPenjualan,
  refundBarang,
  closeModalConfirmationRefundPenjualan,
  openConfirmationRefundPenjualan,
}) {
  const [alasan, setAlasan] = useState('Salah harga');
  const [keterangan, setKeterangan] = useState('');
  const [karyawanId, setKaryawanId] = useState('');
  const [karyawanList, setKaryawanList] = useState([]);

  useEffect(() => {
    if (openConfirmationRefundPenjualan) {
      const fetchKaryawan = async () => {
        try {
          const res = await http.get('/karyawan?is_active=1', {
            headers: { Authorization: getAuthorizationHeader() },
          });
          const list = res.data.data || [];
          setKaryawanList(list);
          if (list.length === 1) {
            setKaryawanId(list[0].id);
          }
        } catch (error) {
          console.error("Gagal mengambil data karyawan", error);
        }
      };
      fetchKaryawan();
    } else {
      setAlasan('Salah harga');
      setKeterangan('');
      setKaryawanId('');
    }
  }, [openConfirmationRefundPenjualan]);

  const handleRefund = () => {
    if (!karyawanId) {
      toast.error('Nama Karyawan wajib dipilih!', { autoClose: 2000 });
      return;
    }

    let finalKeterangan = alasan;
    if (keterangan && keterangan.trim()) {
      if (alasan === 'Lainnya') {
        finalKeterangan = keterangan.trim();
      } else {
        finalKeterangan = `${alasan} - ${keterangan.trim()}`;
      }
    } else if (alasan === 'Lainnya') {
      finalKeterangan = 'Lainnya';
    }

    refundBarang(finalKeterangan, karyawanId);
  };

  return (
    <>
      <Transition appear show={openConfirmationRefundPenjualan} as={Fragment}>
        <Dialog as="div" className="relative z-[100]" onClose={closeModalConfirmationRefundPenjualan}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-slate-900/60 dark:bg-slate-950/80 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 sm:p-6 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-sm sm:max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-[#0f172a] p-6 text-left align-middle shadow-2xl transition-all border border-slate-200 dark:border-slate-800">
                  <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-slate-900 dark:text-white">
                    <div className="flex items-center justify-center">
                      <div className="w-16 h-16 rounded-full bg-amber-50 dark:bg-amber-950/40 border-2 border-amber-500 text-amber-500 flex items-center justify-center shadow-sm">
                        <IconQuestionMark width={38} height={38} stroke={2.5} />
                      </div>
                    </div>
                    <div className="flex justify-center text-xl font-bold mt-4 text-slate-900 dark:text-white">
                      Apakah kamu yakin?
                    </div>
                  </Dialog.Title>
                  <div className="mt-2 text-center">
                    <p className="text-sm text-slate-500 dark:text-slate-400">
                      Silahkan isi keterangan dan tekan tombol return untuk meretur barang{' '}
                      <span className="font-bold text-slate-800 dark:text-slate-200">
                        {detailBarangPenjualan?.item?.jenis_kategori?.nama_jenis || detailBarangPenjualan?.jenis_kategori?.nama_jenis || ''}
                      </span>
                    </p>
                  </div>

                  <div className="mt-4 text-left space-y-3">
                    <div>
                      <label className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1 uppercase tracking-wider">
                        Alasan Retur <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={alasan}
                        onChange={(e) => setAlasan(e.target.value)}
                        className="w-full border border-slate-300 dark:border-slate-700 bg-white dark:bg-[#152037] text-slate-800 dark:text-slate-100 rounded-xl p-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 focus:border-amber-500 cursor-pointer"
                      >
                        <option value="Salah harga" className="dark:bg-slate-800">Salah harga</option>
                        <option value="Salah barang" className="dark:bg-slate-800">Salah barang</option>
                        <option value="Lainnya" className="dark:bg-slate-800">Lainnya</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1 uppercase tracking-wider">
                        Nama Karyawan (Kasir) <span className="text-red-500">*</span>
                      </label>
                      <select
                        value={karyawanId}
                        onChange={(e) => setKaryawanId(e.target.value)}
                        className="w-full border border-slate-300 dark:border-slate-700 bg-white dark:bg-[#152037] text-slate-800 dark:text-slate-100 rounded-xl p-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 focus:border-amber-500 cursor-pointer"
                      >
                        <option value="" className="dark:bg-slate-800">
                          {karyawanList.length === 0 ? '-- Belum ada data karyawan di toko ini --' : '-- Pilih Karyawan --'}
                        </option>
                        {karyawanList.map((k) => (
                          <option key={k.id} value={k.id} className="dark:bg-slate-800">{k.nama_karyawan}</option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1 uppercase tracking-wider">
                        Keterangan <span className="text-slate-400 font-normal lowercase">(opsional)</span>
                      </label>
                      <textarea
                        value={keterangan}
                        onChange={(e) => setKeterangan(e.target.value)}
                        className="w-full border border-slate-300 dark:border-slate-700 bg-white dark:bg-[#152037] text-slate-800 dark:text-slate-100 rounded-xl p-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 focus:border-amber-500 placeholder:text-slate-400 dark:placeholder:text-slate-500"
                        rows={2}
                        placeholder="Catatan tambahan bila ada..."
                      />
                    </div>
                  </div>

                  <div className="mt-6 flex items-center justify-center gap-3">
                    <button
                      type="button"
                      onClick={handleRefund}
                      disabled={loadingRf}
                      className="min-w-[120px] py-2.5 px-6 bg-emerald-500 hover:bg-emerald-600 active:bg-emerald-700 text-white font-bold text-sm rounded-xl shadow-md shadow-emerald-500/20 transition cursor-pointer disabled:opacity-50"
                    >
                      {loadingRf ? 'Proses..' : 'Return'}
                    </button>
                    <button
                      type="button"
                      onClick={closeModalConfirmationRefundPenjualan}
                      className="min-w-[120px] py-2.5 px-6 bg-slate-600 hover:bg-slate-700 active:bg-slate-800 text-white font-semibold text-sm rounded-xl shadow-sm transition cursor-pointer"
                    >
                      Tidak
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
